import { gql } from '@/apollo/gql';

export const PROFILE_QUERY = gql(`
  query myProfile {
    me {
      id
      rowId
      name
      firstName
      lastName
      avatar
      email
      isSuperuser
      isDeveloper
      account {
        id
        rowId
        signingKey {
          rowId
          publicKey
          privateKey {
            rowId
            passwordProtected
            decrypted
          }
        }
      }
      memberOf {
        nodes {
          rowId
          entity {
            ... on Account_Team {
              rowId
              name
              description
              avatar
              organization {
                rowId
                name
                description
                avatar
              }
            }
            ... on Account_Organization {
              rowId
              name
              description
              avatar
              __typename
            }
            ... on Account_User {
              rowId
            }
          }
        }
      }
    }
  }

`);
